// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1_yGm","productName":"Table_productName__13afD"};